import './App.css';
import './index.css';
import Navbar from './components/Navbar';
import Landing from './components/Landing';
import Footer from './components/Footer';
import { LocaleProvider, AuthProvider, WishlistProvider, CartProvider, AuthContext } from './locale';
import Products from './pages/Products';
import Wishlist from './pages/Wishlist';
import AdminWelcome from './pages/AdminWelcome';
import AdminAddProduct from './pages/AdminAddProduct';
import { useEffect, useState, useContext } from 'react';
import AdminProducts from './pages/AdminProducts';
import ProductDetails from './pages/ProductDetails'; // new
import Cart from './pages/Cart'; // new
import Checkout from './pages/Checkout'; // new
import CheckoutSuccess from './pages/CheckoutSuccess'; // new
import AdminOrders from './pages/AdminOrders'; // NEW

const getRoute = () => {
  const hash = window.location.hash;
  
  if (hash.startsWith('#/checkout/success')) return 'checkout-success';
  if (hash.startsWith('#/checkout')) return 'checkout';
  if (hash.startsWith('#/cart')) return 'cart'; // cart route
  if (hash.startsWith('#/products/')) return 'product-details'; // details route
  if (hash.startsWith('#/products')) return 'products';
  if (hash.startsWith('#/wishlist')) return 'wishlist';
  if (hash.startsWith('#/admin/orders')) return 'admin/orders'; // NEW
  if (hash.startsWith('#/admin/products')) return 'admin/products';
  if (hash.startsWith('#/admin/add-product')) return 'admin/add-product';
  if (hash.startsWith('#/admin')) return 'admin';
  return 'home';
};

function AppContent() {
  const [route, setRoute] = useState(getRoute);
  const { user, openAuth } = useContext(AuthContext);

  useEffect(() => {
    const onHash = () => {
      const newRoute = getRoute();
      setRoute(newRoute);
    };
    window.addEventListener('hashchange', onHash);
    if (!window.location.hash) window.location.hash = '#/';
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [route]);

  // Add: protect admin routes for non-admins
  useEffect(() => {
    const isAdminRoute = String(route).startsWith('admin');
    if (isAdminRoute && (!user || user.role !== 'admin')) {
      if (!user) openAuth && openAuth('login');
      window.location.hash = '#/';
    }
  }, [route, user, openAuth]);

  if (user && user.role === 'admin') {
    return (
      <div className="app-root">
        {route === 'admin/add-product' ? <AdminAddProduct /> : 
         route === 'admin/products' ? <AdminProducts /> :
         route === 'admin/orders' ? <AdminOrders /> : // NEW
         <AdminWelcome />}
      </div>
    );
  }

  // Normal user experience
  return (
    <div className="app-root">
      <Navbar />
      <main>
        {/* render one page at a time */}
        {route === 'checkout-success' ? <CheckoutSuccess /> :
         route === 'checkout' ? <Checkout /> :
         route === 'cart' ? <Cart /> :
         route === 'product-details' ? <ProductDetails /> :
         route === 'products' ? <Products /> : 
         route === 'wishlist' ? <Wishlist /> : <Landing />}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <WishlistProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </WishlistProvider>
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
